import { HsocV2Faqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/hsoc/HsocV2Faqs';
import { useTrackSectionViewed } from '../../hooks/useTrackSectionViewed';
import { HSOC_V2_SCREEN, TRACKING_SOURCES, trackClickedLink, trackFaqInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const HsocFaqsSection = () => {
  const sectionRef = useTrackSectionViewed(TRACKING_SOURCES.FAQ, HSOC_V2_SCREEN);
  return /*#__PURE__*/_jsx("div", {
    ref: sectionRef,
    children: /*#__PURE__*/_jsx(HsocV2Faqs, {
      onLinkClick: props => trackClickedLink(Object.assign({}, props, {
        trackingSource: TRACKING_SOURCES.FAQ,
        screen: HSOC_V2_SCREEN
      })),
      onFaqInteraction: trackFaqInteraction
    })
  });
};
export default HsocFaqsSection;